import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

// import { Pig } from '@factorialco/f0-react/icons/app'
import i18n from 'modules/core/lib/i18n'

// import Card from 'modules/marketplace_modules/components/PromotionContent/_Card'

// type Props = {}

const Header = () => {
  return (
    <Box flexDirection="row" gap="s64" alignItems="center" paddingY="s48">
      <Box
        flexDirection="column"
        gap="s4"
        paddingLeft="s24"
        style={{
          maxWidth: '450px',
        }}
      >
        <Tag inline>{i18n.t('marketplace.black_friday_promo.marketplace_list.title_tag')}</Tag>
        <Text size="600" color="white" weight="semibold">
          {i18n.t('marketplace.black_friday_promo.marketplace_list.title')}
        </Text>
        <Text size="400" color="white">
          {i18n.t('marketplace.black_friday_promo.marketplace_list.description_1')}{' '}
          {i18n.t('marketplace.black_friday_promo.marketplace_list.description_2')}{' '}
          {i18n.t('marketplace.black_friday_promo.marketplace_list.description_3')}
        </Text>
      </Box>
      {/* Header Carousel */}
      {/* <Box
        style={{
          position: 'relative',
          flex: '1',
          maxWidth: '800px',
        }}
      >
        <Box
          flexDirection="row"
          gap="s12"
          style={{
            overflowX: 'auto',
            overflowY: 'hidden',
            flexWrap: 'nowrap',
            scrollbarWidth: 'none',
          }}
        >
          <Card
            title="Recruitment"
            description="Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            icon={Pig}
            isHeaderCard
          />
          <Card
            title="Recruitment"
            description="Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            icon={Pig}
            isHeaderCard
          />
          <Card
            title="Recruitment"
            description="Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            icon={Pig}
            isHeaderCard
          />
        </Box>
        <Box
          style={{
            position: 'absolute',
            right: '0',
            top: '0',
            bottom: '0',
            width: '150px',
            background:
              'linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(26,14,31,0.5) 50%, rgba(26,14,31,1) 100%)',
            pointerEvents: 'none',
            zIndex: '10',
          }}
        />
      </Box> */}
    </Box>
  )
}

export default Header
